<template>
  <div
    class="full-size quiz-box"
    :class="{'image-quiz': slideActive.slideType == 'imageChoice'}"
  >
    <div
      class="step-1 full-size vertical layout"
      v-if="isLobbyScreen"
    >
      <div class="title-slide text-animation animate__animated animate__pulse animate__infinite">
        <span>{{ $t("waitingForPlayerToJoin") }}</span>

        <span class="count-player-lobby">
          <span v-if="$store.state.countPlayer == 1">
            {{ $t('player', { msg: formatNumber($store.state.countPlayer) }) }}
          </span>
          <span v-if="$store.state.countPlayer > 1">
            {{ $t('players', { msg: formatNumber($store.state.countPlayer) }) }}
          </span>
          <span
            class="ml-1"
            v-if="$store.state.presentation.teamPlay && $store.state.countPlayer > 0"
          >
            <span v-if="$store.state.presentation.teamActive === 1">
              {{ $t('inTeam', { num: $store.state.presentation.teamActive}) }}
            </span>
            <span v-if="$store.state.presentation.teamActive > 1">
              {{ $t('inTeams', { num: $store.state.presentation.teamActive}) }}
            </span>
          </span>
        </span>
      </div>
      <div class="flex vertical layout">
        <div class="flex">
          <div id="word-cloud" class="horizontal layout center-justified" />
          <QuizTeamGameLobby v-if="$store.state.presentation.teamPlay" />
        </div>
        <div
          class="text-center start-game"
          :class="{'m-t-20': $store.state.isSyncing == 3 || $store.state.socketDisconnect}"
        >
          <button class="btn btn-primary" @click="startQuizAllScreens()" :disabled="disableStart">
            {{ $t("startButton") }}
          </button>
          <p>
            {{ $t("youCanAlsoPress") }}
            <kbd class="keyboard-key">→</kbd>
          </p>
        </div>
      </div>
    </div>
    <transition name="slide-fade">
      <div
        class="step-2 full-size vertical layout center center-justified"
        v-if="slideActive.quizStatus == QuizStatuses.RULE_SCREEN"
      >
        <div v-if="indexSlide !== null && totalQuiz">
          <p
            class="count-question"
          >
            {{ $t("numberQuestionOfQuiz", {msg: indexSlide + 1, num: totalQuiz}) }}
          </p>

          <p
            v-if="slideActive.fastAnswerGetMorePoint"
            class="note-point"
          >
            {{ $t("fasterGetMorePointsRule") }}
          </p>
          <p
            v-if="!slideActive.fastAnswerGetMorePoint"
            class="note-point"
          >
            {{ $t("correctAnswerGetMaxPointTitle") }}
          </p>
          <div class="icon-step-2">
            <i
              class="fas fa-stopwatch fa-4x animate__animated animate__tada animate__delay-1s"
              v-if="slideActive.fastAnswerGetMorePoint"
            />
          </div>
          <p
            v-if="!slideActive.fastAnswerGetMorePoint"
            class="small-note-point"
          >
            {{ $t("correctAnswerGetMaxPointDetail") }}
          </p>
        </div>
      </div>
    </transition>
    <transition name="slide-fade">
      <div
        class="text-center step-3 full-size vertical layout"
        v-if="slideActive.quizStatus == QuizStatuses.COUNTDOWN_5S_SCREEN"
      >
        <div
          class="flex vertical layout center-justified"
          :class="{'center no-image': !slideActive.image}"
        >
          <div :class="{'countdown-has-image': slideActive.image}">
            <div v-if="slideActive.image">
              <img :src="slideActive.image.xLarge" alt>
            </div>
            <div
              id="countdown"
              v-show="startCount"
              :class="{'countdown-bg': !slideActive.image}"
            >
              <div id="countdown-number" />
              <svg v-show="!slideActive.image">
                <circle r="107" cx="120" cy="120" />
              </svg>
            </div>
            <p v-if="showWaitingScreen3 == 1">
              {{ $t("lookAtYourPhone") }}
            </p>
            <p v-if="showWaitingScreen3 == 2">
              {{ $t("getReadyScene2") }}
            </p>
            <p v-if="showWaitingScreen3 == 3">
              <span
                class="loading-spinner"
                :class="{'black': slideActive.textColour == '#313131'}"
              /> {{ $t("stillTrying") }}
            </p>
            <p v-if="showWaitingScreen3 == 4" class="error-step-3">
              <i class="fas fa-exclamation-circle" /> {{ $t("establishConnection") }}
            </p>
          </div>
        </div>
      </div>
    </transition>
    <transition name="slide-fade">
      <div
        class="step-4 full-size vertical layout"
        v-if="slideActive.quizStatus == QuizStatuses.QUESTION_SCREEN ||
          slideActive.quizStatus == QuizStatuses.RESULT_SCREEN"
      >
        <div class="full-size fullsize-safari">
          <div
            :class="{'has-background': isButtonShowAnswersVisible,
                     'dark-theme': isButtonShowAnswersVisible && isTextColourLight}"
          ></div>
          <div
            class="has-image-quiz"
            v-if="isQuizImageVisible"
          >
            <img :src="slideActive.image.xLarge" alt>
          </div>

          <div
            class="has-show-count-down"
            v-show="slideActive.hideResult && countTimeToAnswer <= 3 && !everyoneVoted "
          >
            <div
              class="time-number"
              ref="countToAnswer"
              v-show="countTimeToAnswer && countTimeToAnswer > 0"
            />
            <div
              class="time-up animate__bounceIn animate__animated"
              v-if="canShowTimesUp"
            >
              {{ $t("timesUp") }}
            </div>
          </div>
          <div class="has-show-count-down" v-if="everyoneVoted">
            <div
              class="time-up animate__bounceIn animate__animated"
              style="font-size: 44px;"
            >
              {{ $t("everyoneHasAnswered") }}
            </div>
          </div>
          <transition name="fade">
            <div
              v-if="isButtonShowAnswersVisible"
            >
              <button
                class="reveal-correct-answers-button"
                @click="showQuizResult(false)"
              >
                {{ $t('Show answers') }}
              </button>
            </div>
          </transition>

          <QuizTimeRemainingBox
            :countTimeToAnswer="countTimeToAnswer"
            :everyoneVoted="everyoneVoted"
            :animationTimeToAnswer="animationTimeToAnswer"
            :boxWaitBg="boxWaitBg"
          />

          <BarChart
            v-if="isBarChartVisible"
          />
          <CustomBarChart
            v-if="isCustomBarChartVisible"
          />

          <CustomBarChartQuizType
            v-if="isCustomBarChartQuizTypeVisible"
            :key="typeAnswerQuizContentComponentKey"
          />

          <AcceptedTypeAnswer
            v-if="isAcceptedTypeAnswerVisible"
          />

          <MatchPairsContent
            v-if="$store.state.slideActive.slideType == 'matchPairs'"
          />

          <CorrectOrderContent
            v-if="$store.state.slideActive.slideType == 'correctOrder'"
          />
        </div>
      </div>
    </transition>

    <ConfirmModal
      :data="dataConfirm"
      @handleModalConfirmOk="handleModalConfirmOk"
      @handleModalConfirmCancel="handleModalConfirmCancel"
      v-if="$store.state.quizConfirmation"
    />
  </div>
</template>

<script>
import * as Sentry from '@sentry/vue'
import { mapState, mapActions, mapGetters } from 'vuex'
import colorUtils from 'storybook-utils/colors'
import Util from '@/util'
import Config from '@/config'
import Constant from '@/constant'
import BarChart from '@/components/presentations/charts/BarChart.vue'
import CustomBarChart from '@/components/presentations/charts/CustomBarChart.vue'
import CustomBarChartQuizType from '@/components/presentations/charts/CustomBarChartQuizType.vue'
import EventBus from '@/eventBus'
import Socket from '@/socket'
import ConfirmModal from '@/components/ConfirmModal.vue'
import QuizTeamGameLobby from '@/components/presentations/contents/QuizTeamGameLobby.vue'
import AcceptedTypeAnswer from '@/components-v2/presentation-editor/accepted-type-answer/AcceptedTypeAnswer.vue'
import MatchPairsContent from '@/components-v2/presentation-editor/match-pairs/MatchPairsContent.vue'
import CorrectOrderContent from '@/components-v2/presentation-editor/correct-order/CorrectOrderContent.vue'
import QuizTimeRemainingBox from '@/components-v2/presentation-editor/middle/QuizTimeRemainingBox.vue'
import lobbyMusic from '@/assets/audio/lobby-music2.mp3'
import socketHelper from '@/helpers/socket/socket-helper'
import QuizStatuses from '@/constant/QuizStatuses'

export default {
  components: {
    BarChart,
    CustomBarChart,
    ConfirmModal,
    CustomBarChartQuizType,
    QuizTeamGameLobby,
    AcceptedTypeAnswer,
    MatchPairsContent,
    CorrectOrderContent,
    QuizTimeRemainingBox,
  },
  data() {
    return {
      // clusters: null,
      indexSlide: null,
      totalQuiz: 0,
      startCount: false,
      animationTimeToAnswer: 'countdown-wait 5s linear forwards',
      countTimeToAnswer: 0,
      intervalTimeToAnswer: null,
      intervalCountdownCycle: null,
      timeoutStartQuiz: null,
      timeoutCountdownCycle: null,
      everyoneVoted: false,
      showWaitingScreen3: 1,
      disableStart: true,
      timeoutEnableStart: null,
      typeAnswerQuizContentComponentKey: 0,
      dataConfirm: {
        modalType: 'confirmQuiz',
        class: 'quiz-modal-confirmation',
        textOk: 'Leave',
        textCancel: 'Stay',
        title: '',
        description: "This Quiz question is still running. If you're sure you want to leave, please hit the same key again.",
      },
      requestFrame: null,
      isStopCloud: false,
      boxWaitBg: '',
      QuizStatuses: Constant.QuizStatuses,
      isShowQuizResultButton: false,
    }
  },
  computed: {
    ...mapGetters(['isBackstage', 'isPresenting']),
    ...mapState({
      presentation: (state) => state.presentation,
      slideActive: (state) => state.slideActive,
      filteringProfanity: (state) => state.presentation.filteringProfanity,
    }),
    canShowTimesUp() {
      return this.slideActive.quizStatus === Constant.QuizStatuses.RESULT_SCREEN &&
        this.isTimesUp
    },
    isTimesUp() {
      return !this.countTimeToAnswer || this.countTimeToAnswer < 0
    },
    isTextColourLight() {
      return this.slideActive.textColour === '#ffffff'
    },
    isLobbyScreen() {
      return this.slideActive.quizStatus == this.QuizStatuses.LOBBY_SCREEN
    },
    isBarChartVisible() {
      return this.slideActive.SlideOptions.length && !this.slideActive.slideType
    },
    isCustomBarChartVisible() {
      return this.slideActive.SlideOptions.length && this.slideActive.slideType == 'imageChoice'
    },
    isCustomBarChartQuizTypeVisible() {
      const { slideType, showAcceptedAnswerView } = this.slideActive
      return slideType === 'typeAnswer' && !showAcceptedAnswerView
    },
    isAcceptedTypeAnswerVisible() {
      return this.slideActive.slideType == 'typeAnswer' &&
              this.slideActive.showAcceptedAnswerView
    },
    isButtonShowAnswersVisible() {
      return this.presentation.manualRevealCorrectAnswers &&
        this.isShowQuizResultButton &&
        !this.slideActive.showCorrectOption
    },
    isQuizImageVisible() {
      const { slideType, image, hideResult } = this.slideActive
      const slideTypes = ['matchPairs', 'correctOrder']
      return !slideTypes.includes(slideType) && image && hideResult &&
      this.countTimeToAnswer > 3 && !this.everyoneVoted
    },
  },
  watch: {
    '$store.getters.isPresenting': function (isPresenting) {
      if (!isPresenting) {
        this.updateSlide({
          quizStatus: Constant.QuizStatuses.LOBBY_SCREEN,
        })
        this.updateSlideActiveAction({
          quizStatus: Constant.QuizStatuses.LOBBY_SCREEN,
          hideResult: false,
          showCorrectOption: true,
        })
      } else {
        this.updateSlideActiveAction({
          hideResult: true,
          showCorrectOption: false,
        })
      }
    },
    'slideActive.showCorrectOption': function watchShowCorrectOption(showCorrectOption) {
      if (showCorrectOption) {
        this.showQuizResult(false)
      }
    },
    'slideActive.quizStatus': function watchQuizStatus(quizStatus) {
      if (quizStatus === QuizStatuses.RESULT_SCREEN && this.presentation.manualRevealCorrectAnswers && !this.slideActive.showCorrectOption) {
        setTimeout(() => {
          this.isShowQuizResultButton = true
        }, 500)
      }
    },
    filteringProfanity() {
      if (!this.presentation.teamPlay) {
        this.renderWordCloud()
      }
    },
  },
  created() {
    if (!this.lobbyMusic) {
      this.lobbyMusic = new Audio(lobbyMusic)
      this.lobbyMusic.loop = true
    }
  },
  mounted() {
    this.cleanUpTimers()
    const self = this
    self.everyoneVoted = false
    this.updateHideResult(true)
    if (this.isBackstage) {
      this.$store.state.slideActive.showQuestionImage = false
    }

    const quizs = this.presentation.slides.filter((item) => {
      return item.type == 'pickAnswer'
    })
    const index = Util.getIndexSlide(quizs, this.$store.state.slideActive.id)
    this.checkSlideMovingDirectionAction(this.$store.state.slideActive.id)
    this.indexSlide = index
    this.totalQuiz = quizs.length
    if (this.$store.state.continueQuiz) {
      self.startQuizThisScreen()
    } else {
      this.updateSlideActiveAction({
        quizStatus: Constant.QuizStatuses.LOBBY_SCREEN,
      })
      this.playQuizLobbyMusic()
    }

    if (this.slideActive.quizStatus != Constant.QuizStatuses.LOBBY_SCREEN &&
      this.slideActive.quizStatus !== Constant.QuizStatuses.RULE_SCREEN
    ) {
      this.updateSlide({
        quizStatus: this.$store.state.slideActive.quizStatus,
        questionCount: this.totalQuiz,
        questionIndex: index + 1,
      })
      this.pauseQuizLobbyMusic()
    }

    if (!this.presentation.teamPlay) {
      setTimeout(() => {
        this.renderWordCloud()
      }, 200)
    }

    EventBus.$on('quiz-bus', () => {
      if (!this.presentation.teamPlay) {
        if (self.isStopCloud == true) return
        if (self.myWordCloud) {
          self.myWordCloud.update(self.getWords())
        } else {
          self.renderWordCloud()
        }
      }
    })

    EventBus.$on('start-quiz', () => {
      this.startQuizAllScreens()
    })

    EventBus.$on('start-quiz-on-other-screen', () => {
      this.$store.state.originScreen = false
      self.startQuizThisScreen()
    })

    EventBus.$on('play-quiz-music', (isEnableQuizMusic) => {
      if (!this.lobbyMusic) return
      if (isEnableQuizMusic) {
        this.playQuizLobbyMusic()
        Util.gaTrackEvent(
          Constant.gaCategories.PRESENTATION_EDITOR,
          'Presenting mode > Enable Lobby Quiz Music',
        )
      } else {
        this.pauseQuizLobbyMusic()
        Util.gaTrackEvent(
          Constant.gaCategories.PRESENTATION_EDITOR,
          'Presenting mode > Disable Lobby Quiz Music',
        )
      }
    })

    EventBus.$on('everyone-voted', () => {
      if (!this.everyoneVoted) {
        this.everyoneVoted = true
        this.updateSlideActiveAction({
          quizStatus: Constant.QuizStatuses.QUESTION_SCREEN,
          everyoneVoted: true,
        })
        setTimeout(() => {
          this.isShowQuizResultButton = true
        }, 500)
        this.countTimeToAnswer = 0
        this.updateSlideActiveAction({
          quizStatus: Constant.QuizStatuses.RESULT_SCREEN,
        })
        this.updateSlide({
          quizStatus: Constant.QuizStatuses.RESULT_SCREEN,
        })
        if (!this.presentation.manualRevealCorrectAnswers) {
          this.showQuizResult()
        }

        if (this.intervalTimeToAnswer) {
          clearInterval(this.intervalTimeToAnswer)
        }
      }
    })

    EventBus.$on('enableQuizStart', (id) => {
      if (id == self.$store.state.slideActive.id) {
        self.disableStart = false
      }
    })

    EventBus.$on('accept-other-type-answers-from-backstage', () => {
      this.typeAnswerQuizContentComponentKey += 1
    })

    if (
      this.presentation.presenting &&
      !this.isPresenting &&
      !this.isBackstage &&
      this.presentation.id
    ) {
      this.$http
        .put(
          Config.api.updatePresentation + this.presentation.id,
          {
            presenting: false,
            socketId: Socket.getSocketId(),
            activeSlidePreseting: this.$store.state.slideActive.id,
            activeSlideAccessCode: this.presentation.uniqueAccessCode,
          },
        )
        .then(
          () => {},
          () => {},
        )
    }

    if (!this.isPresenting && !this.isBackstage) {
      this.updateSlideActiveAction({
        showCorrectOption: true,
      })
    }

    this.timeoutEnableStart = setTimeout(() => {
      self.disableStart = false
      self.timeoutEnableStart = null
    }, 4000)

    if (this.$store.state.slideActive.baseColour) {
      const rgbaColour = Util.hexToRgba(this.$store.state.slideActive.baseColour)
      this.boxWaitBg = Util.changeRgbaColor(rgbaColour, 0.6)
      if (!this.boxWaitBg || this.boxWaitBg == '') {
        this.boxWaitBg = this.$store.state.slideActive.baseColour
      }
    }
    this.updateSlideActiveAction({
      showAcceptedAnswerView: false,
    })

    try {
      // FIXME: Consider removing this as there should be any reason why we need a specific class for safari. This was added by Loi to fix an issue with safari but we lost track of the original issue. @huongnguyen2152 15.05.2020
      // eslint-disable-next-line
      let isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
      const ua = window.navigator.userAgent
      const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i)
      const webkit = !!ua.match(/WebKit/i)
      const iOSSafari = iOS && webkit && !ua.match(/CriOS/i)
      if (isSafari || iOSSafari) {
        document.body.classList.add('safari-env')
      }
    } catch (error) {
      Sentry.captureException(error)
    }
  },

  destroyed() {
    this.cleanUpTimers()

    EventBus.$off('quiz-bus')
    EventBus.$off('start-quiz')
    EventBus.$off('start-quiz-on-other-screen')
    EventBus.$off('enableQuizStart')
    EventBus.$off('everyone-voted')
    EventBus.$off('show-quiz-result')
    EventBus.$off('accept-other-type-answers-from-backstage')
    EventBus.$off('play-quiz-music')

    if (this.lobbyMusic) {
      this.lobbyMusic.pause()
      delete this.lobbyMusic
    }
  },
  methods: {
    ...mapActions(['updateSlideActiveAction', 'checkSlideMovingDirectionAction']),
    formatNumber: Util.formatNumber,
    handleModalConfirmCancel() {
      this.$store.state.quizConfirmation = false
      this.$store.state.quizConfirmationType = null
    },
    handleModalConfirmOk() {
      EventBus.$emit('eventHandleNextSlide', this.$store.state.quizConfirmationType)
    },
    getWords() {
      let arr = []
      const options = []
      let blockAudiences = []

      let count = 0
      Object.keys(this.$store.state.audiences).forEach((key) => {
        if (count < 70) {
          count++
          options.push({ ...this.$store.state.audiences[key] })
        } else if (!this.isStopCloud) {
          this.isStopCloud = true
        }
      })

      try {
        if (localStorage.getItem('blockAudiences')) {
          blockAudiences = JSON.parse(localStorage.getItem('blockAudiences'))
        }
      } catch (error) {
        Sentry.captureException(error)
        blockAudiences = []
      }

      options.forEach((item, key) => {
        item.index = key
        try {
          const indexAudienceBlock = blockAudiences.findIndex(
            (audienceData) => {
              return audienceData == item.audience
            },
          )

          if (indexAudienceBlock != -1) {
            item.isCensorName = true
            item.censorName = Util.censorName(item.audienceName)
          }
        } catch (error) {
          Sentry.captureException(error)
        }

        if (!item.offline && item.audienceName) {
          const text = `${item.audienceEmoji} ${item.audienceName}`

          const objAudience = {
            text,
            originalText: text,
            count: 1,
            countText: text.length,
            index: item.index,
            audience: item.audience,
            isCensorName: item.isCensorName,
            censorName: item.censorName,
          }

          if (item.isCensorName) {
            objAudience.text = `${item.audienceEmoji} ${item.censorName}`
          } else {
            objAudience.text = Util.filterProfaneWordsWrapper(objAudience.originalText)
          }
          if (arr.length < 60) {
            arr.push(objAudience)
          }
        }
      })
      arr = arr.sort((a, b) => {
        return b.countText - a.countText
      })
      if (arr.length) {
        let total = 0
        const pool = 5000
        // let offSet;
        arr.forEach((item) => {
          total += item.count
        })

        arr.forEach((item) => {
          item.percent = (item.count / total) * 100
          // offSet = getFontSize(arr.length);

          item.size = Math.sqrt((pool / 100) * item.percent)
          // item.size = item.size * (1 - item.text.length/100*0.75); // set the font size smaller as the string gets longer
          if (item.size > 32) {
            item.size = 32
          } else if (item.size < 16) {
            item.size = 16
          }

          if (item.audience) {
            // Color for audience join the lobby screen
            item.color = colorUtils.getAudienceColor(item.audience)
          } else {
            // Color for each word in the wordcloud slide
            let indexColor = item.index
            if (item.index > 29) {
              indexColor = item.index - parseInt(item.index / 29, 10) * 29
            }
            if (this.$store.state.slideActive.textColour == '#ffffff') {
              item.color = Constant.lighterColors[indexColor]
            } else {
              item.color = Constant.colors[indexColor]
            }
          }
        })
        arr[0].isMax = true
      }
      return arr
    },
    renderWordCloud() {
      const self = this
      const { d3 } = window
      if (document.getElementById('word-cloud')) {
        document.getElementById('word-cloud').innerHTML = ''
      }
      const fontFamily = "'Nunito', sans-serif"

      // Simple animated example of d3-cloud - https://github.com/jasondavies/d3-cloud
      // Based on https://github.com/jasondavies/d3-cloud/blob/master/examples/simple.html

      // Encapsulate the word cloud functionality

      // Encapsulate the word cloud functionality
      function wordCloud(selector) {
        // Construct the word cloud's SVG element
        const svg = d3
          .select(selector)
          .append('svg')
          .attr('width', 1180)
          .attr('height', 400)
          .append('g')
          .attr('transform', 'translate(590,200)')

        // Draw the word cloud
        function draw(words) {
          const cloud = svg.selectAll('g text').data(words, (d) => {
            d.text = Util.filterProfaneWordsWrapper(d.text)
            return d.text
          })

          // Entering words
          cloud
            .enter()
            .append('text')
            .style('font-family', fontFamily)
            .style('cursor', 'pointer')
            // .style('font-weight', 'bold') // Do not bold! AHA-8191
            .style('fill', (d) => {
              return d.color
            })
            .attr('text-anchor', 'middle')
            .attr('font-size', 1)
            .text((d) => {
              return d.text
            })
            .on('click', (d) => {
              d.isCensorName = !d.isCensorName
              if (d.isCensorName) {
                d.censorName = Util.censorName(d.originalText)
              }
              Util.saveBlockAudience(d)
              self.myWordCloud.update(self.getWords())
              Util.gaTrackEvent(
                'Presentation Editing',
                'Presenter censor name',
                `Presentation: ${self.$store.state.presentation.id}, Censor: ${d.isCensorName}`,
              )
            })

          // Entering and existing words
          cloud
            .transition()
            .duration(600)
            .style('font-size', (d) => {
              return `${d.size}px`
            })
            .attr('transform', (d) => {
              return `translate(${[d.x, d.y]})rotate(${d.rotate})`
            })
            .style('fill-opacity', 1)

          // Exiting words
          cloud
            .exit()
            .transition()
            .duration(200)
            .style('fill-opacity', 1e-6)
            .attr('font-size', 1)
            .remove()
        }

        // Use the module pattern to encapsulate the visualisation code. We'll
        // expose only the parts that need to be public.
        return {
          // Recompute the word cloud for a new set of words. This method will
          // asycnhronously call draw when the layout has been computed.
          // The outside world will need to call this function, so make it part
          // of the wordCloud return value.
          update(words) {
            d3.layout
              .cloud()
              .size([1180, 400])
              .words(words)
              .padding(10)
              .rotate(() => {
                return 0
              })
              .font("'Nunito', sans-serif")
              .fontSize((d) => {
                return d.size
              })
              .on('end', draw)
              .start()
          },
        }
      }

      // Some sample data - http://en.wikiquote.org/wiki/Opening_lines

      // Prepare one of the sample sentences by removing punctuation,
      // creating an array of words and computing a random size attribute.

      // This method tells the word cloud to redraw with a new set of words.
      // In reality the new words would probably come from a server request,
      // user input or some other source.
      function showNewWords(vis) {
        vis.update(self.getWords())
      }

      // Create a new instance of the word cloud visualisation.
      self.myWordCloud = wordCloud('#word-cloud')

      // Start cycling through the demo data
      showNewWords(self.myWordCloud)
    },

    _startCountDownTimeToAnswer() {
      const self = this

      self.countTimeToAnswer = JSON.parse(
        JSON.stringify(this.$store.state.slideActive.timeToAnswer),
      )
      if (!this.$store.state.slideActive.quizTimestamp) {
        this.updateSlideActiveAction({
          quizTimestamp: [],
        })
      }
      let contextTimeToAnswer = document.getElementById('timeLeftToAnswer')
      if (contextTimeToAnswer) {
        contextTimeToAnswer.textContent = Util.timeToString(
          self.countTimeToAnswer,
        )
      }

      let secondTime = 0
      const startTime = new Date().getTime() + this.$store.state.slideActive.timeToAnswer * 1000

      function step(timestamp) {
        const timeRun = parseInt(timestamp / 1000, 10)
        if (secondTime != timeRun) {
          secondTime = timeRun

          self.countTimeToAnswer = parseInt((startTime - new Date().getTime()) / 1000, 10)
          contextTimeToAnswer = document.getElementById('timeLeftToAnswer')

          if (contextTimeToAnswer) {
            contextTimeToAnswer.textContent = Util.timeToString(
              self.countTimeToAnswer,
            )
            if (self.$refs.countToAnswer) {
              self.$refs.countToAnswer.innerHTML = ''
              self.$refs.countToAnswer.innerHTML =
                `<div class='animate__bounceIn animate__animated'>${
                  self.countTimeToAnswer
                }</div>`
            }

            if (self.isTimesUp &&
            self.$store.state.slideActive.quizStatus != Constant.QuizStatuses.RESULT_SCREEN) {
              self.updateSlideActiveAction({
                quizStatus: Constant.QuizStatuses.RESULT_SCREEN,
              })
              self.updateSlide({
                quizStatus: Constant.QuizStatuses.RESULT_SCREEN,
              })
              if (self.presentation.manualRevealCorrectAnswers) {
                setTimeout(() => {
                  self.isShowQuizResultButton = true
                }, 500)
              } else {
                self.showQuizResult()
              }
            }
          }
        }
        if (self.countTimeToAnswer > -3) {
          self.requestFrame = window.requestAnimationFrame(step)
        } else {
          self.requestFrame = null
        }
      }
      self.requestFrame = window.requestAnimationFrame(step)
    },
    updateHideResult(boolean) {
      if (!boolean) {
        this.updateSlideActiveAction({
          showCorrectOption: true,
        })
      }
      this.updateSlideActiveAction({
        hideResult: boolean,
      })

      if (this.presentation.manualRevealCorrectAnswers) {
        const socketId = Socket.getSocketId()
        const accessCode = this.presentation.uniqueAccessCode
        const presentationId = this.presentation.id
        const presenting = this.isPresenting || this.isBackstage
        const slideId = this.slideActive.id
        this.$http
          .put(Config.api.updateSlide + slideId, {
            showCorrectOption: !boolean,
            socketId,
            accessCode,
            presentationId,
            presenting,
          })
      }
    },

    _startQuizOtherScreen() {
      socketHelper.backstageControl({
        uniqueAccessCode: this.presentation.uniqueAccessCode,
        type: 'start-quiz-on-other-screen',
        data: this.slideActive.id,
      })
    },

    _startCountDownCycle() {
      this.startCount = true
      const self = this
      const countdownNumberEl = document.getElementById('countdown-number')
      if (!countdownNumberEl) return
      let countdown = 5
      countdownNumberEl.textContent = countdown
      this.intervalCountdownCycle = setInterval(() => {
        if (countdown > 0) {
          countdown--
        }
        countdownNumberEl.textContent = countdown
        if (!countdown || countdown == 0) {
          self.updateHideResult(true)
          self.animationTimeToAnswer =
            `countdown-wait ${
              self.$store.state.slideActive.timeToAnswer
            }s linear forwards`

          self.updateSlide(
            {
              quizStatus: Constant.QuizStatuses.QUESTION_SCREEN,
              quizTimestamp: self.$store.state.slideActive.quizTimestamp,
            },
            () => {
              self.startCountdownTimeAnswerTimeout = setTimeout(() => {
                self._startCountDownTimeToAnswer()
              }, 200)
              this.updateSlideActiveAction({
                quizStatus: Constant.QuizStatuses.QUESTION_SCREEN,
              })
            },
          )

          window.clearInterval(self.intervalCountdownCycle)
          self.intervalCountdownCycle = null
          self.showWaitingScreen3 = 2
          self.showWaitingScreen3Timeout = setTimeout(() => {
            if (self.showWaitingScreen3 != 4) {
              self.showWaitingScreen3 = 3
            }
          }, 2000)
        }
      }, 1000)
    },

    startQuizAllScreens() {
      this.$store.state.originScreen = true
      this.startQuizThisScreen()
      this._startQuizOtherScreen()
    },

    startQuizThisScreen() {
      this.cleanUpTimers()
      this.pauseQuizLobbyMusic()
      this.$store.state.continueQuiz = true
      this.showWaitingScreen3 = 1
      this.updateHideResult(true)
      this.updateSlideActiveAction({
        quizStatus: Constant.QuizStatuses.RULE_SCREEN,
        showCorrectOption: false,
        isShowQuizResultButton: false,
      })

      this.$store.state.tempAudienceCount = this.$store.state.slideActive.multipleCountAnswer
      this.updateSlide({
        quizStatus: Constant.QuizStatuses.RULE_SCREEN,
        questionCount: this.totalQuiz,
        questionIndex: this.indexSlide + 1,
      })

      this.timeoutStartQuiz = setTimeout(() => {
        let status = Constant.QuizStatuses.COUNTDOWN_5S_SCREEN
        if (!this.presentation.enableQuizCoundown) {
          status = Constant.QuizStatuses.QUESTION_SCREEN
        }
        if (status === 3) {
          this.updateSlideActiveAction({
            quizStatus: status,
          })
          this.updateSlide({
            quizStatus: status,
          })
          this.startCountdown5sTimeout = setTimeout(() => {
            this._startCountDownCycle()
          }, 200)
        } else {
          this.updateHideResult(true)
          this.animationTimeToAnswer =
            `countdown-wait ${
              this.$store.state.slideActive.timeToAnswer
            }s linear forwards`
          this.updateSlideActiveAction({
            quizStatus: status,
          })
          this.updateSlide({
            quizStatus: status,
          })
          this.startCountdownTimeAnswerTimeout = setTimeout(() => {
            this._startCountDownTimeToAnswer()
          }, 200)
        }
        this.timeoutStartQuiz = null
      }, 3000)
    },

    cleanUpTimers() {
      if (this.intervalTimeToAnswer) {
        clearInterval(this.intervalTimeToAnswer)
      }
      if (this.intervalCountdownCycle) {
        clearInterval(this.intervalCountdownCycle)
      }
      if (this.timeoutStartQuiz) {
        clearTimeout(this.timeoutStartQuiz)
      }
      if (this.timeoutCountdownCycle) {
        clearTimeout(this.timeoutCountdownCycle)
      }
      if (this.timeoutEnableStart) {
        clearTimeout(this.timeoutEnableStart)
      }
      if (this.startCountdownTimeAnswerTimeout) {
        clearTimeout(this.startCountdownTimeAnswerTimeout)
      }
      if (this.startCountdown5sTimeout) {
        clearTimeout(this.startCountdown5sTimeout)
      }
      if (this.requestFrame) {
        cancelAnimationFrame(this.requestFrame)
        this.requestFrame = null
      }
      if (this.showQuestionOnOtherScreenTimeout) {
        clearTimeout(this.showQuestionOnOtherScreenTimeout)
      }
    },

    updateSlide(payload, cb) {
      if (this.$store.state.sharePresentation) {
        return
      }
      const slideId = this.$store.state.slideActive.id
      payload.socketId = Socket.getSocketId()
      payload.accessCode = this.presentation.uniqueAccessCode
      payload.presentationId = this.presentation.id
      payload.presenting = this.isPresenting || this.isBackstage
      // Backstage: Chỉ có screen điều khiển (originScreen) mới gọi API,
      // còn screen còn lại sẽ tự chơi quiz dựa vào thay đổi quizStatus
      // (giống self-paced quiz ở audience)
      if (this.$store.state.originScreen) {
        this.$http
          .put(Config.api.updateSlide + slideId, payload)
          .then(() => {
            // the time we receive the response, slide active might change
            // so make sure we invoke the callback for the current slide only
            if (cb && this.$store.state.slideActive.id === slideId) {
              cb()
            }
          }, (err) => {
            if (cb) {
              this.showWaitingScreen3 = 4
              this.$store.dispatch('setSyncPresentation', 3)
              this.$http.post(Config.api.quizHook, {
                presentationId: this.presentation.id,
                accessCode: this.presentation.accessCode,
                uniqueCode: this.presentation.uniqueAccessCode,
                slideId: this.$store.state.slideActive.id,
                error: JSON.stringify(err),
              }).then(() => {}, () => {})
            }
          })
      } else if (cb) {
        this.showQuestionOnOtherScreenTimeout = setTimeout(cb, 1000)
      }
    },
    playQuizLobbyMusic() {
      if (this.presentation.isEnableQuizMusic && this.lobbyMusic && !this.isBackstage) {
        this.lobbyMusic.play().catch(() => {})
      }
    },
    pauseQuizLobbyMusic() {
      if (this.lobbyMusic) {
        this.lobbyMusic.pause()
      }
    },

    showQuizResult(delay = true) {
      if (this.slideActive.quizStatus !== QuizStatuses.RESULT_SCREEN) {
        return
      }
      setTimeout(() => {
        this.updateHideResult(false)
        Util.uploadSlide(
          this.$store.state.slideActive,
          this.$store.state.presentation,
        )
        this.everyoneVoted = false
        this.countTimeToAnswer = null
      }, delay ? 2000 : 0)

      if (this.$store.state.slideActive.type == 'pickAnswer' && this.$store.state.slideActive.slideType == 'typeAnswer') {
        EventBus.$emit('eventShowQuizTypeAnswer')
      }
      EventBus.$emit('close-modal-quiz-show-results')
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";

#countdown.countdown-bg {
  background-color: rgba(240, 240, 240, 0.6);
  border-radius: 100%;
}

#countdown-number {
  display: inline-block;
  line-height: 240px;
  font-size: 80px;
  font-weight: bold;
}

.time-up {
  font-size: 80px;
  font-weight: bold;
}

.has-show-count-down {
  position: absolute;
  width: 800px;
  height: 260px;
  top: 80px;
  left: 50%;
  margin-left: -400px;
  text-align: center;
  line-height: 260px;
  z-index: 11;

  .time-number {
    font-size: 200px;
    font-weight: bold;
  }
}

.reveal-correct-answers-button {
  position: absolute;
  top: 270px;
  left: 50%;
  z-index: 300;
  transform: translateX(-50%);
  border-radius: 20px;
  border: 1px solid #333;
  font-weight: bold;
  transition: all 0.2s ease;
  padding: 4px 16px;
  @apply bg-base-0 text-base-90;
  &:hover {
    @apply bg-brand-a100 text-base-0;
  }
}

.has-image-quiz {
  position: absolute;
  top: 10px;
  left: 50%;
  width: 800px;
  margin-left: -400px;
  z-index: 10;

  img {
    max-height: 210px;
    display: block;
    margin: 0 auto;
    max-width: 800px;
  }
}

.progress-bar-animation {
  background-color: #fff;
  border: 1px solid #fff;
  height: 24px;
  width: 50%;
  margin: 20px auto;
  margin-bottom: 0;
  overflow: hidden;
  .line-bar {
    height: 22px;
    width: 100%;
    background-color: $primary-color;
    animation: progress-bar 5s;
    animation-timing-function: linear;
  }
}

/* Safari 4.0 - 8.0 */
@-webkit-keyframes progress-bar {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}

/* Standard syntax */
@keyframes progress-bar {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}
.step-3 {
  p {
    font-size: 30px;
    font-weight: bold;
    margin: 16px 0;
    margin-top: 0;

    &.error-step-3 {
      font-size: 26px;
    }
  }

  .no-image {
    p {
      margin-top: 50px;
    }
  }
}
.step-2 {
  text-align: center;

  .fa-ban {
    color: $primary-color;

    &.white {
      color: #fff;
      opacity: 0.5;
    }
  }

  .icon-step-2 {
    margin-bottom: 16px;
    .fas.fa-stopwatch {
      font-size: 62px;
    }
  }

  p {
    margin-bottom: 0;
    font-size: 1.6em;

    &.count-question {
      font-size: 40px;
      font-weight: bold;
    }

    &.small-note-point {
      opacity: 0.7;
      font-size: 32px;
      padding: 0 350px;
      margin-bottom: 0;
    }

    &.note-point {
      margin-bottom: 16px !important;
      font-size: 35px;
    }
  }
}
.quiz-box {
  padding: 0 16px;
}

.title-slide {
  font-size: 2em;
  line-height: 1.2em !important;
  font-weight: bold;

  &.text-animation {
    font-size: 40px;
    text-align: center;
    margin: 16px 0 0;
    line-height: initial !important;
    padding-right: 0 !important;
    @media (max-width: 812px) {
      margin: 11px 0 0;
    }
  }
}

.keyboard-key {
  display: inline-block;
  height: 20px;
  width: 30px;
  font-size: 20px;
  color: #757575;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 3px;
  vertical-align: middle;
  -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.1);
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.1);
  line-height: 0.4;
}

.start-game {
  &.m-t-20 {
    margin-top: -20px;
  }
  .btn {
    border-radius: 40px;
    font-size: 24px;
    margin-bottom: 16px;
    padding-left: 32px;
    padding-right: 32px;
    border: 1px solid #fff;
  }

  p {
    font-size: 18px;
    opacity: 0.8;
  }
  @media (max-width: 768px) and (orientation: landscape) {
    .btn {
      font-size: 21px;
      margin-bottom: 0;
    }
  }
}

.countdown-has-image {
  img {
    max-height: 184px;
    margin: 0 auto;
    @media (max-width: 812px) {
      max-height: 152px;
    }
  }

  #countdown {
    height: 140px;
  }

  #countdown-number {
    line-height: 140px;
  }
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.5s cubic-bezier(0.25, 1, 0.5, 1);
}
.slide-fade-leave-active {
  transition: all 0.4s cubic-bezier(0.12, 0, 0.39, 0);
}
//cubic-bezier(0.32, 0, 0.67, 0)

.slide-fade-enter {
  transform: translateX(75px);
  opacity: 0;
}

.slide-fade-leave-to {
  transform: translateX(-75px);
  opacity: 0;
}
.count-player-lobby {
  opacity: 0.4;
  font-weight: normal;
  font-size: 34px;
}

.image-quiz {
  .has-image-quiz {
    top: 10px;

    img {
      max-height: 170px;
    }
  }
}
.has-background {
  position: absolute;
  top: 55%;
  left: 50%;
  width: 1280px;
  margin-top: -189px;
  margin-left: -640px;
  background-color: rgba(240, 240, 240, 0.8);
  padding: 0 0 22%;
  z-index: 10;
  &.dark-theme {
    background-color: rgba(0, 0, 0, 0.48);
  }
  @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
    -webkit-backdrop-filter: blur(5px);
    backdrop-filter: blur(5px);
  }
}
</style>
